import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.error || 'Anmeldung fehlgeschlagen');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div style={{ fontSize: 22, fontWeight: 700, color: 'var(--blue)', letterSpacing: 1 }}>DV ELEKTRO</div>
          <div style={{ fontSize: 12, color: 'var(--text-2)', marginTop: 3 }}>Mitarbeiterportal</div>
        </div>
        <div className="login-title">Anmelden</div>
        <div className="login-sub">Bitte mit deinen Zugangsdaten anmelden</div>
        {error && <div className="login-error">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-group" style={{ marginBottom: 14 }}>
            <label className="form-label">Benutzername</label>
            <input className="form-input" value={form.username} onChange={e => setForm(f => ({...f, username: e.target.value}))} autoFocus autoComplete="username" />
          </div>
          <div className="form-group" style={{ marginBottom: 20 }}>
            <label className="form-label">Passwort</label>
            <input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({...f, password: e.target.value}))} autoComplete="current-password" />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%', justifyContent: 'center' }}>
            {loading ? 'Wird angemeldet…' : 'Anmelden'}
          </button>
        </form>
      </div>
    </div>
  );
}
